/**
 * TanStack Query wrapper for `testRunsAPI.getById(runId)`.
 *
 * Used by run-detail to fetch the run metadata (currently for
 * `testSuiteId` lookups powering the suite-name header). Cached
 * indefinitely — a run's metadata is stable once written.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { testRunsAPI } from '@/lib/api'
import type { TestRun } from '@/types'

export function useTestRun(
  runId: string | undefined,
): UseQueryResult<TestRun | null> {
  return useQuery({
    queryKey: ['test-run', runId],
    queryFn: () => {
      if (!runId) throw new Error('useTestRun: runId required')
      return testRunsAPI.getById(runId)
    },
    enabled: !!runId,
    staleTime: Infinity,
  })
}
